export default __webpack_public_path__ + "static/media/videocam.5f696f60.svg";